<template>
  <wrap-container>
    <help-title title="Blanqueo de Pin Banelco" />

    <help-list-container>
      <help-list-item tituloLista="Banca Online:">
        Ingresá con tu Usuario y Clave Digital a Tarjetas ➜ Visa Débito ➜ Voy a
        ➜ Blanquear PIN y Clave Línea BBVA 0800-333-0303 - Sistema automático.
        Opciones: 4 (tarjetas) ➜ 2 (tarjetas visa débito) ➜ 4 (Blanqueo de PIN
        Banelco). Deberás contar con tu Clave BBVA (4 dígitos)
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    ContactLink
  }
};
</script>
